// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ayXV","col":"styles_col__1xlIT","actions":"styles_actions__1nGV0","conflict":"styles_conflict__13Ioh"};